import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreferenceState {
    isOpen: boolean;
}
const initialState: PreferenceState = {
    isOpen: false,
};
const PreferenceSlice = createSlice({
    name: 'PreferenceState',
    initialState,
    reducers: {
        setPreferenceOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setPreferenceOpen } = PreferenceSlice.actions;
export default PreferenceSlice.reducer;
